<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-form v-model="valid" style="width:100%" ref="createOrganizationForm" @submit="save" onSubmit="return false">
            <v-container fluid>
                <v-layout>
                    <v-flex md4>
                        <v-text-field counter="100"
                                      label="Organization Name"
                                      v-model="organization.name"
                                      ref="organizationName"
                                      :rules="serverValidation('name','Organization Name')">

                        </v-text-field>
                    </v-flex>
                    <v-flex md4>
                        <v-text-field counter="100"
                                      label="Tip Submission E-Mail"
                                      v-model="organization.tipEmail"
                                      :rules="serverValidation('tipEmail','Tip Submission E-Mail')">
                        </v-text-field>
                    </v-flex>
                </v-layout>
                <v-radio-group v-model="cadOption">
                    <template v-slot:label>
                        CAD Configuration
                    </template>
                    <v-radio label="Create New Configuration" value="NEW"></v-radio>
                    <v-radio label="Use Existing" value="EXISTING"></v-radio>
                    <v-radio label="No CAD Configuration (Standalone)" value="NONE"></v-radio>
                </v-radio-group>
                <v-layout v-if="cadOption == 'EXISTING'">
                    <v-flex md4>
                        <v-select :items="cadConfigurations"
                                  label="CAD Configuration"
                                  item-text="description"
                                  v-model="organization.cadConfigurationId"
                                  required
                                  item-value="id"></v-select>
                    </v-flex>
                </v-layout>
                <div v-if="cadOption == 'NEW'">
                    <v-layout>
                        <v-flex md6>
                            <v-text-field counter="100" label="CAD Name" v-model="organization.cadDescription"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex md3>
                            <v-text-field counter="100" label="CAD URL" v-model="organization.cadUrl"></v-text-field>
                        </v-flex>
                        <v-flex md3>
                            <v-text-field counter="100" label="CAD Tenant" v-model="organization.cadTenant"></v-text-field>
                        </v-flex>
                        <v-flex md3>
                            <v-text-field counter="100" label="CAD Username" v-model="organization.cadUsername"></v-text-field>
                        </v-flex>
                        <v-flex md3>
                            <v-text-field counter="100" label="CAD Password" v-model="organization.cadPassword"></v-text-field>
                        </v-flex>
                    </v-layout>
                </div>
                <v-layout>
                    <v-btn outlined class="mx-2" type="button" @click="cancel()" color="warning" :disabled="overlay">Cancel</v-btn>
                    <v-btn outlined class="mx-2" type="submit" color="success" :disabled="overlay">Save</v-btn>
                    <v-progress-circular
                            :width="3"
                            v-show="overlay"
                            color="red"
                            indeterminate="">
                    </v-progress-circular>
                </v-layout>
            </v-container>
        </v-form>
    </div>
</template>

<script>
    import api from '@/api';
    import {validationMixin} from '@/mixins/validations'

    export default {
        name: 'CreateOrganization',
        mixins:[validationMixin],
        data() {
            return {
                valid: false,
                organization : {},
                overlay : false,
                cadConfigurations: [],
                cadOption: 'NEW'
            }
        },
        watch: {
            cadOption(newValue) {
                if (newValue == 'NONE' || newValue == 'EXISTING') {
                    this.organization.cadUrl = null;
                    this.organization.cadTenant = null;
                    this.organization.cadUsername = null;
                    this.organization.cadPassword = null;
                    this.organization.cadConfigurationId = null;
                    this.organization.cadDescription = null;
                }
            }
        },
        mounted() {
            api.cadConfig.search().then((configs) =>{
                this.cadConfigurations = configs.list;
                this.$refs.organizationName.focus();
            });
        },
        methods : {

            reset() {
                this.organization = {};
                this.overlay = false;
                this.violations = [];
            },
            isEmpty(str) {
                return str == '' || str == null || str == undefined || str == 0;
            },
            save() {

                if (this.cadOption == 'NEW' &&
                    (this.isEmpty(this.organization.cadUrl) ||
                    this.isEmpty(this.organization.cadTenant) ||
                    this.isEmpty(this.organization.cadUsername) ||
                    this.isEmpty(this.organization.cadDescription) ||
                    this.isEmpty(this.organization.cadPassword))) {
                    this.$root.$emit('globalMessage','Please Specify All CAD Configuration Fields');
                    return;
                } else if (this.cadOption == 'EXISTING' && this.isEmpty(this.organization.cadConfigurationId)) {
                    this.$root.$emit('globalMessage','Please Specify A CAD Configuration');
                    return;
                }

                this.overlay = true;
                api.organization.post(this.organization).then((org) => {
                    this.reset();
                    this.$router.replace('/organization/'+org.id);
                    this.$root.$emit('globalMessage','Organization Created');
                }, (error) => {
                    if (this.processErrors(error) == this.RESPONSE_VALIDATION) {
                        this.$refs.createOrganizationForm.validate();
                    }
                }).finally(this.overlay = false);
            },
            cancel() {
                this.$router.go(-1);
            }

        }
    }
</script>